// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { logPageView } from './utils/analytics';
import AppLayout from './components/layout/AppLayout';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Import pages
import LandingPage from './pages/LandingPage';
import ProductsPage from './pages/ProductsPage';
import DemoPage from './pages/DemoPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import SampleReportPage from './pages/SampleReportPage';
import AdminPage from './pages/AdminPage';
import CrossLicensingSolution from './pages/solutions/CrossLicensingSolution';
import PortfolioOptimizationSolution from './pages/solutions/PortfolioOptimizationSolution';

// Component to track page views on route changes
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change using our analytics utility
    logPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <RouteTracker />
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <ScrollToTop>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/solutions/cross-licensing" element={<AppLayout><CrossLicensingSolution /></AppLayout>} />
                <Route path="/solutions/portfolio-optimization" element={<AppLayout><PortfolioOptimizationSolution /></AppLayout>} />
                <Route path="/products" element={<AppLayout><ProductsPage /></AppLayout>} />
                <Route path="/demo" element={<AppLayout><DemoPage /></AppLayout>} />
                <Route path="/about" element={<AppLayout><AboutPage /></AppLayout>} />
                <Route path="/sample-report" element={<AppLayout><SampleReportPage /></AppLayout>} />
                <Route path="/contact" element={<AppLayout><ContactPage /></AppLayout>} />
                <Route path="/privacy" element={<AppLayout><PrivacyPolicy /></AppLayout>} />
                <Route path="/terms" element={<AppLayout><TermsOfService /></AppLayout>} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </ScrollToTop>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;